<template>
  <Dialog
      v-model:visible="visible"
      :header="t('NOTIFICATION')"
      modal
      :draggable="false"
      :dismissable-mask="true"
      class="group-notification-modal"
      @hide="handleClose"
  >
    <div class="text14-black">
      <Textarea
          class="w-100"
          id="details"
          name="details"
          rows="6"
          :placeholder="t('WRITE_STH')"
          v-model="message"
      />

      <div class="mt-3">
        <h5 class="text-center">{{ t("RECIPIENTS") }}:</h5>

        <div class="d-flex justify-content-center">
          <ul v-if="trainees" class="list-unstyled">
            <li v-for="trainee of trainees" :key="trainee.id" class="flex align-items-center mb-2">
              <Checkbox :input-id="'trainee-' + trainee.id" v-model="trainee.doSendInvitation" :binary="true"/>
              <label :for="'trainee-' + trainee.id" class="ms-2">{{ trainee.email }}</label>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <template #footer>
      <Button
          :label="t('SEND')"
          :disabled="!message || loading || !selectedTraineeIds.length"
          @click="sendNotification"
      />
    </template>
  </Dialog>
</template>

<script setup>
import {computed, ref} from "vue";
import {injectAxios} from "@/util/inject";
import {useI18n} from "vue-i18n";
import {useRoute} from "vue-router";
import {useToast} from "@/util/toastUtils.js";

const route = useRoute();
const axios = injectAxios();
const {t} = useI18n();
const toast = useToast();
const emits = defineEmits(["afterSave"]);

const trainees = ref([]);
const message = ref(null);
const loading = ref(false);
const visible = ref(false);

function handleClose() {
  trainees.value = [];
  message.value = null;
  visible.value = false;
}

function showGroupNotificationModal(traineesData) {
  trainees.value = traineesData?.map((t) => ({...t.trainee, doSendInvitation: !t.isInvitationSent})) ?? [];
  visible.value = true;
}

const selectedTraineeIds = computed(() => {
  return trainees.value.filter((t) => t.doSendInvitation).map((t) => t.id);
});

async function sendNotification() {
  loading.value = true;

  try {
    await axios.post(`/training/group/notification/${route.params.id}`, {
      message: message.value,
      traineeIds: selectedTraineeIds.value,
    });
  } finally {
    loading.value = false;
  }

  trainees.value = [];
  message.value = null;
  visible.value = false;
  emits("afterSave");
  toast.makeSuccessToast(t("OPERATION_SUCCESSFUL"));
}

defineExpose({
  showModal: showGroupNotificationModal,
});
</script>
